// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: label, icon and colour for each mail swipe action, shared by the
// list rows, the short-swipe trays and Settings > Mail > Swipe actions.

import type {MailSwipeTone} from '@app/features/konvo_mail/components/MailSwipeRow';
import type {MailSwipeAction} from '@app/features/konvo_mail/state/MailSwipePreferences';
import {
	ArchiveIcon,
	ArrowBendUpLeftIcon,
	BellIcon,
	CheckSquareIcon,
	EnvelopeSimpleOpenIcon,
	FlagIcon,
	FolderIcon,
	ProhibitIcon,
	PushPinIcon,
	TrashIcon,
} from '@app/features/ui/icons/Icons';
import type {MessageDescriptor} from '@lingui/core';
import {msg} from '@lingui/core/macro';
import type React from 'react';

export const MAIL_SWIPE_ACTION_LABEL: Record<MailSwipeAction, MessageDescriptor> = {
	toggle_read: msg({message: 'Read', comment: 'Mail swipe action that toggles read/unread. Short tile label.'}),
	flag: msg({message: 'Flag', comment: 'Mail swipe action. Short tile label.'}),
	reply: msg({message: 'Reply', comment: 'Mail swipe action. Short tile label.'}),
	archive: msg({message: 'Archive', comment: 'Mail swipe action. Short tile label.'}),
	delete: msg({message: 'Delete', comment: 'Mail swipe action. Short tile label.'}),
	remind: msg({message: 'Remind', comment: 'Mail swipe action that sets a reminder. Short tile label.'}),
	task: msg({message: 'Task', comment: 'Mail swipe action that makes a ClickUp task. Short tile label.'}),
	move: msg({message: 'Move', comment: 'Mail swipe action that moves the mail to a folder. Short tile label.'}),
	pin: msg({
		message: 'Pin',
		comment: 'Mail swipe action that pins the mail to the top of its folder. Short tile label.',
	}),
	none: msg({message: 'None', comment: 'Mail swipe setting: the swipe does nothing. Short tile label.'}),
};

export const MAIL_SWIPE_ACTION_TONE: Record<Exclude<MailSwipeAction, 'none'>, MailSwipeTone> = {
	toggle_read: 'read',
	flag: 'flag',
	reply: 'reply',
	archive: 'archive',
	delete: 'delete',
	remind: 'remind',
	task: 'task',
	move: 'move',
	pin: 'pin',
};

export function mailSwipeActionIcon(action: MailSwipeAction, size = 22): React.ReactNode {
	switch (action) {
		case 'toggle_read':
			return <EnvelopeSimpleOpenIcon size={size} />;
		case 'flag':
			return <FlagIcon size={size} />;
		case 'reply':
			return <ArrowBendUpLeftIcon size={size} />;
		case 'archive':
			return <ArchiveIcon size={size} />;
		case 'delete':
			return <TrashIcon size={size} />;
		case 'remind':
			return <BellIcon size={size} />;
		case 'task':
			return <CheckSquareIcon size={size} />;
		case 'move':
			return <FolderIcon size={size} />;
		case 'pin':
			return <PushPinIcon size={size} />;
		case 'none':
			return <ProhibitIcon size={size} />;
	}
}
